import React from 'react'
import {connect} from 'react-redux'
import {FAQSelector, CustomizationSelector, CompanySelector} from '/app/src/model/selectors'
import DateTime from '/app/src/lib/DateTime'

import {Flex, HelpDeskItemPreview} from '/app/src/component'

/*
    This component reads from currentPayload in state. It is used to
    actively preview the FAQ article in use.

*/
class UpdatingPreview extends React.Component {
    render() {
        return (
            <Flex hAlignContent='center' bg='grey1' h='100%' w='100%'>
                <Flex w='90%' mt='20px'>
                    <HelpDeskItemPreview {...this.props} />
                </Flex>
            </Flex>
        )
    }
}

function mapStateToProps(state, ownProps) {
    const {itemId} = ownProps;
    const color = CustomizationSelector.getColor(state);
    const faq = FAQSelector.getFAQById(state, itemId);
    const tempPayload = FAQSelector.getCurrentPayload(state);
    let answer = ''
    let question = ''
    let authorName = ''
    let authorImg = ''
    if (tempPayload) {
        answer = tempPayload.answer
        question = tempPayload.question;
        authorName = tempPayload.authorName;
        authorImg = tempPayload.authorImg;
    }

    let dateModified = FAQSelector.getDateModified(faq);
    dateModified = DateTime.formatDate(dateModified, 'yyyy-mm-dd').replace(/-/g, '/')
    const companyName = CompanySelector.getCompanyName(state);

    return { question, answer, authorName, dateModified, authorImg, color, companyName};
}

export default connect(mapStateToProps)(UpdatingPreview)



// WEBPACK FOOTER //
// ./src/layout/Dashboard/RightPanel/ClientChatMenu/HelpDesk/CategoryUpdate/UpdatingPreview/index.js